// NPM
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'actions';

import { currentUserSelector, selectUserResult } from 'selectors';
import { isRegistered } from 'services/userInfoService';

import Layout from 'Components/Layout/Layout';
// import Sponsor from 'Components/Layout/Sponsor';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { MODAL_NAME, FORM_KEYS } from 'Components/Auth/AuthModal';

class Landing extends Component {
  openAuthModal = () => {
    this.props.openModal(MODAL_NAME, { formToDisplay: FORM_KEYS.login });
  };

  getButtonProps = () => {
    const { currentUserResult, user } = this.props;
    if (currentUserResult.uuid) {
      return {
        text: 'View result',
        link: `/results/${currentUserResult.uuid}`,
      };
    } else if (isRegistered(user)) {
      return { text: 'Continue Survey', link: '/survey' };
    } else {
      return { text: 'Get started', link: '/survey' };
    }
  };

  render() {
    const buttonProps = this.getButtonProps();
    return (
      <Layout>
        <div className="Landing-holder">
          <h1 className="Landing-heading">Where should I go to university?</h1>
          <p className="Landing-desc">
            In just 10 minutes, we can help you make a more informed decision
            about a school and program that is best suited to your skills,
            goals, and interests.
          </p>
          <Link to={buttonProps.link} className="Landing-btn btn">
            {buttonProps.text}
          </Link>
          {!isRegistered(this.props.user) && (
            <p className="Landing-returning">
              Returning?{' '}
              <Button onClick={this.openAuthModal} bsStyle="link">
                Log in to view results
              </Button>
            </p>
          )}
          <svg viewBox="0 0 100 100" className="Landing-square">
            <rect x="0" y="0" width="100" height="100" fill="transparent" />
          </svg>
          <div className="Landing-hero">
            {
              // <Sponsor className="Landing-sponsor mobile-only" />
            }
          </div>
        </div>
      </Layout>
    );
  }
}

function mapStateToProps(state, props) {
  return {
    user: currentUserSelector(state),
    currentUserResult: selectUserResult(state),
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openModal: actions.openModal,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing);



// WEBPACK FOOTER //
// ./src/Components/Pages/Landing.js